import { Component, ViewEncapsulation, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'lib-multi-column-layout',
  standalone: true,
  imports: [CommonModule, CardModule],
  templateUrl: './multi-column-layout.component.html',
  styleUrl: './multi-column-layout.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class MultiColumnLayoutComponent {
  showMobileSidebar = input(false);
}
